import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/j_spring_security_check',
    method: 'post',
    params: {
      j_username: username,
      j_password: password
    }
  })
}

export function getInfo(token) {
  return request({
    url: '/fwUser/getCurrentFwUser',
    method: 'get',
    params: { token }
  })
}
export function logout() {
  return request({
    url: '/logout',
    method: 'get'
  })
}
export function getWxLoginUrl(params) {
  return request({
    url: '/cmsUser/getWxLoginUrl',
    method: 'get',
    params
  })
}
export function wxLoginCallback(params) {
  return request({
    url: '/cmsUser/wxLoginCallback',
    method: 'post',
    params
  })
}
export function userIsBinding(params) {
  return request({
    url: '/cmsUser/userWxUserRegister',
    method: 'post',
    params
  })
}
export function userWxUserRegister(params) {
  return request({
    url: '/cmsUser/userWxUserRegister',
    method: 'post',
    params
  })
}

export function wxUpdateCallback(params) {
  return request({
    url: '/cmsUser/wxUpdateCallback',
    method: 'post',
    params
  })
}

/**
 * 解绑微信
 * @param params
 */
export function deleteWeiXinUser(params) {
  return request({
    url: '/cmsUser/deleteWeiXinUser',
    method: 'post',
    params
  })
}

/**
 * 绑定微信前验证手机号
 * @param params
 * @constructor
 */
export function IsPhoneCode(params) {
  return request({
    url: '/cmsUser/IsPhoneCode',
    method: 'post',
    params
  })
}
/**
 * 绑微信二维码
 * @param params
 */
export function addWeiXinUserUrl() {
  return request({
    url: '/cmsUser/addWeiXinUserUrl',
    method: 'post'
  })
}
/**
 * 绑微信
 * @param params
 */
export function wxBindingCallback(params) {
  return request({
    url: '/cmsUser/wxBindingCallback',
    method: 'post',
    params
  })
}
// /手机号验重
export function getPhoneIs(params) {
  return request({
    url: '/cmsUser/getPhoneIs',
    method: 'post',
    params
  })
}

export function addWxBindingUser(params) {
  return request({
    url: 'cmsUser/addWxBindingUser',
    method: 'post',
    params
  })
}
// //单点登录
export function addLoginState(params) {
  return request({
    url: 'ssoLogin/addLoginState',
    method: 'post',
    params
  })
}

